<template>
  <div class="snap-container">
    <section class="snap-section1">
      <coverVersion />
    </section>
  </div>
</template>

<script>
import coverVersion from "@/components/CoverVersion.vue";

export default {
  components: {
    coverVersion
  }
};
</script>
